// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1GNO9","title":"Info_title__3jZ84","links":"Info_links__3mbQw","link":"Info_link__28g5W","logo":"Info_logo__3nn_W"};